/**
 * 获取商品参考价：先 `referencePrice` 再 `referenceprice`，保留合法 `0`（与历史 `getProductReferencePrice` 语义一致）。
 */
export function getReferencePrice(item: Record<string, any> | null | undefined): string | number {
	if (!item) return '';
	if (item.referencePrice || item.referencePrice === 0) return item.referencePrice;
	if (item.referenceprice || item.referenceprice === 0) return item.referenceprice;
	return '';
}
/**
 * 列表等场景「标价」取值顺序：**`price` 优先**，再 `referencePrice`、`referenceprice`；
 * 与 **m-mall-dc** `src/pages/index/components/SmallImg.vue` 中 `methods.getPrice` 一致（含 `== 0`）。
 */
export function getPrice(item: Record<string, any> | null | undefined): string | number {
	if (!item) return '';
	if (item.price || item.price == 0) return item.price;
	if (item.referencePrice || item.referencePrice == 0) return item.referencePrice;
	if (item.referenceprice || item.referenceprice == 0) return item.referenceprice;
	return '';
}

/**
 * 获取商品价格类型，兼容 priceType/pricetype，并保留 0 值。
 * @param item 商品对象
 * @return 返回接口中的价格类型；如果接口未返回则返回 undefined
 */
export function getProductPriceType(item: Record<string, any> | null | undefined): string | number | undefined {
	if (!item) return undefined;
	if (item.priceType || item.priceType === 0) return item.priceType;
	if (item.pricetype || item.pricetype === 0) return item.pricetype;
	return undefined;
}

/**
 * 判断商品是否应展示为“合作价”。
 * @param item 商品对象
 * @return 当 priceType/pricetype 为 1 且参考价为 0 时返回 true，否则返回 false
 */
export function isCooperationPrice(item: Record<string, any> | null | undefined): boolean {
	const priceType = getProductPriceType(item);
	if (priceType === undefined) return false;
	if (!item) return false;
	const referencePrice =
		item.referencePrice || item.referencePrice === 0
			? item.referencePrice
			: item.referenceprice || item.referenceprice === 0
				? item.referenceprice
				: undefined;
	if (referencePrice === undefined) return false;
	return Number(priceType) === 1 && Number(referencePrice) === 0;
}

/** 列表/购物车等与 ShowAmount、`utils.priceFormat` 一致的合作价展示文案 */
export const COOPERATION_PRICE_DISPLAY = '合作价';

/**
 * 若为合作价商品则返回列表展示用固定文案；否则返回 null（由调用方继续做 formatPrice / 控销）。
 */
export function getCooperationListPriceLabel(item: Record<string, any> | null | undefined): typeof COOPERATION_PRICE_DISPLAY | null {
	return isCooperationPrice(item) ? COOPERATION_PRICE_DISPLAY : null;
}

/**
 * 将价格补全接口中的字段安全合并到商品对象，兼容大小写与 0 值。
 * 补价接口大小写字段不稳定，且 referencePrice=0 对合作价是有效值，不能被 || 丢掉。
 * @param target 目标商品对象
 * @param source 价格补全接口返回对象
 * @return 返回合并后的目标商品对象
 */
export function mergeProductPriceFields(target: Record<string, any>, source: Record<string, any> | null | undefined) {
	if (!target || !source) return target;
	target.referencePrice = source.referencePrice || source.referencePrice === 0 ? source.referencePrice : source.referenceprice;
	target.referenceprice = source.referenceprice || source.referenceprice === 0 ? source.referenceprice : source.referencePrice;
	target.priceType = source.priceType || source.priceType === 0 ? source.priceType : source.pricetype;
	target.pricetype = source.pricetype || source.pricetype === 0 ? source.pricetype : source.priceType;
	return target;
}
